export interface Version {
  versionName: string;
  version: string;
}

export interface ApplicationInfo {
  name: string;
  company: string;
  versions: Version[];
}

export interface ShipmentApiVersion {
  applicationInfo: ApplicationInfo;
}

export enum ShipmentPermissions {
  CanRead = 'CanRead',
  CanEdit = 'CanEdit'
}

export enum UsersPermissions {
  ApiKey = 'ApiKey'
}